import React, {Component} from "react";
import {Link} from "react-router-dom";
import IconEdit from 'react-icons/lib/fa/edit';
import IconImage from 'react-icons/lib/fa/image';
import IconVideo from 'react-icons/lib/fa/video-camera';
import IconRecomend from "react-icons/lib/fa/thumbs-up"
import IconBlacklist from "react-icons/lib/fa/minus-square"
import IconOverride from "react-icons/lib/fa/retweet"
import IconAdd from "react-icons/lib/fa/plus"

var axios = require('axios');
var _ = require('lodash');

class VenueList extends Component
{
	constructor(props)
	{
		super(props);

		this.state = {
			items: [],
			pagination: {
				min: 0,
				max: 0
			},
			locations: []
		};
	}
	componentDidMount()
	{
		this.getLocations()
			.then(response => {

				let features = response.data.features;

				let locations = [];

				features.forEach(function(feature){
					locations.push({
						label: feature.properties.name,
						geometry: feature.geometry
					});
				});

				let newState = {...this.state};
				newState.locations = locations;

				this.setState(newState);

				this.fetchVenues();
			})
			.catch(error => {
				console.log(error);
			});
	}
	getLocations = () => {
		return new Promise((fulfil, reject) => {

			axios.get(process.env.REACT_APP_API_ROOT + "locations/london/")
				.then(fulfil)
				.catch(reject);
		});
	}
	fetchVenues = () => {
		let range = {
			start: this.props.filters.page * this.props.filters.quantity,
			end: ((this.props.filters.page + 1) * this.props.filters.quantity) - 1
		};

		let location = {"type":"Polygon","coordinates":[[[-0.511,51.693],[0.338,51.693],[0.338,51.286],[-0.511,51.286],[-0.511,51.693]]]};

		this.state.locations.forEach(item => {

			if (item.label === this.props.filters.area)
			{
				location = item.geometry;
			}
		});

		// set standard search parameters
		let parameters = {
			location: location,
			options: {
				active: true
			},
			name: this.props.filters.name,
			sort: {
				field: "name",
				direction: "asc"
			}
		};

		// add mood and recommended search terms if required
		if (this.props.filters.mood === true)
		{
			parameters.mood = "";
		}

		if (this.props.filters.recommended === true)
		{
			parameters.options.recommended = true;
		}

		this.props.getVenues(range, parameters)
			.then(response => {
				let newState = {...this.state};
				newState.pagination.max = Math.ceil(this.props.parseRange(response.headers['content-range']) / this.props.filters.quantity) - 1;
				newState.items = response.data;

				this.setState(newState);
			})
			.catch(error => {
				console.log(error);
			});
	}
	onFilterChange = (event) => {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		this.props.updateFilter("venues", name, value);
	}
	setPage = (number) => {
		if (number < this.state.pagination.min)
		{
			number = this.state.pagination.min;
		}

		if (number > this.state.pagination.max)
		{
			number = this.state.pagination.max;
		}

		this.props.updateFilter("venues", "page", number);

		this.fetchVenues();
	}
	addNew()
	{
		window.location = "/venues/add/";
	}
	render()
	{
		document.title = "DateNight: Venues";

		return (
			<div>
				<h2>Venues</h2>
				<Link className="venues__add-new-btn btn" to="/venues/new/">Add New <IconAdd /></Link>
				<Filters locations={this.state.locations} filters={this.props.filters} pagination={this.state.pagination} setPage={this.setPage} onFilterChange={this.onFilterChange} fetchVenues={this.fetchVenues} />
				<Table items={this.state.items} />
				<Pagination filters={this.props.filters} pagination={this.state.pagination} setPage={this.setPage} />
			</div>
		);
	}
}

class Table extends Component
{
	render()
	{
		let trs = "";

		if (this.props.items.length === 0)
		{
			trs = (
				<tr>
					<td colSpan="11">No results found</td>
				</tr>
			);
		}
		else {
			trs = this.props.items.map(item => {
				let className = "";

				if (item.options.blacklisted === true) {
					className = "blacklisted";
				}
				else if (item.options.recommended === true) {
					className = "recommended";
				}

				let url = "/venues/" + item.id + "/";

				let imagery = (item.photos !== undefined) ? <span className="icon" title="Has imagery"><IconImage /></span> : "";
				let recommended = (item.options.recommended === true) ? <span className="icon" title="Has video"><IconRecomend /></span> : "";
				let blacklisted = (item.options.blacklisted === true) ? <span className="icon" title="Recommended"><IconBlacklist /></span> : "";
				let overridden = (item.options.rating === true) ? <span className="icon" title="Blacklisted"><IconOverride /></span> : "";
				let video = (item.video !== undefined) ? <span className="icon" title="Overridden"><IconVideo /></span> : "";

				let moods = [];

				if(!!item.mood) {
					moods = item.mood.map(mood => _.startCase(mood)) || [];
				}

				return (
					<tr className={className} key={item.id}>
						<td>{item.feed}</td>
						<td>{item.name}</td>
						<td>{_.startCase(item.type)}</td>
						<td>{moods.join(' // ')}</td>
						<td className="icons-column">{imagery}{video}{recommended}{blacklisted}{overridden}</td>
						<td>{item.rating}</td>
						<td>
							<Link to={url}><IconEdit /></Link>
						</td>
					</tr>
				);
			});
		}

		return (
			<table className="dataTable venues">
				<thead>
				<tr>
					<th>Feed</th>
					<th>Name</th>
					<th>Type</th>
					<th>Mood</th>
					<th>Attributes</th>
					<th>Rating</th>
					<th>Actions</th>
				</tr>
				</thead>
				<tbody>
					{trs}
				</tbody>
			</table>
		);
	}
}

class Pagination extends Component
{
	render()
	{
		return (
			<div className="pagination">
				<button className="btn" onClick={() => this.props.setPage(this.props.filters.page - 1)}>Previous</button>
				{this.props.filters.page + 1} of {this.props.pagination.max + 1}
				<button className="btn" onClick={() => this.props.setPage(this.props.filters.page + 1)} >Next</button>
			</div>
		);
	}
}

class Filters extends Component
{
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.setPage(this.props.pagination.min);
	}
	render()
	{
		let values = [10, 20, 50, 100];

		let options = this.props.locations.map(item => {
			return <option key={item.label} value={item.label}>{item.label}</option>
		});

		return (
			<form className="filters" onSubmit={this.handleSubmit}>
				<div className="form-input third">
					<label>Name</label>
					<input name="name" type="text" onBlur={this.props.onFilterChange} />
				</div>
				<div className="form-input">
					<label>Area</label>
					<select name="area" value={this.props.filters.area} onChange={this.props.onFilterChange}>
						<option value="all">All</option>
						{options}
					</select>
				</div>
				<div className="form-input">
					<label>Per Page</label>
					<select name="quantity" value={this.props.filters.quantity} onChange={this.props.onFilterChange}>
						{
							values.map(value => {
								return <option key={value} value={value}>{value}</option>;
							})
						}
					</select>
				</div>
				<div className="form-input">
					<label><input name="mood" type="checkbox" value={this.props.filters.mood} onChange={this.props.onFilterChange} /> Missing "Mood"</label>
					<label><input name="recommended" type="checkbox" value={this.props.filters.recommended} onChange={this.props.onFilterChange} /> Recommended</label>
				</div>
				<div className="form-input centered">
					<input type="submit" value="Filter" className="btn" />
				</div>
			</form>
		);
	}
}

export default VenueList;



// WEBPACK FOOTER //
// ./src/components/VenueList.js